import { Checkbox } from 'components/Form/Checkboxes/Checkbox';
import React from 'react';
import tw from 'twin.macro';
import { DiffCompetenceList } from './DiffCompetenceList';
import { DiffNote } from './DiffNote';
import { LivretEleve } from 'containers/Livrets/types/livret';
import { NotationSystem } from 'types/notationSystem';
import {
  buildDiffKey,
  findCurrentCompetenceList,
  findCurrentNote,
} from './utils';
import { LivretEleveDiff } from './types';
import _isEmpty from 'lodash-es/isEmpty';

interface Props {
  diff: LivretEleveDiff;
  onSelect: () => void;
  isSelected: boolean;
  notationSystem: NotationSystem;
  livretEleve: LivretEleve;
}

export function SyncDiffTableRow({
  diff,
  livretEleve,
  onSelect,
  isSelected,
  notationSystem,
}: Props) {
  const rowKey = buildDiffKey(diff);
  const currentNote = findCurrentNote(
    livretEleve,
    diff.matiereCode,
    diff.domaineCode,
    diff.competence,
  );
  return (
    <tr key={rowKey}>
      <td tw="relative p-3">
        <div
          css={[
            tw`absolute inset-y-0 left-0 w-1`,
            isSelected && tw`bg-brand-intense`,
          ]}
        />
        <Checkbox onChange={onSelect} checked={isSelected} />
      </td>
      <td tw="p-3">{diff.domaine || diff.matiere}</td>
      <td tw="p-3">
        {diff.competence ? (
          // positionnement par compétence
          diff.competence
        ) : (
          <DiffCompetenceList
            prevCompetenceList={findCurrentCompetenceList(
              livretEleve,
              diff.matiereCode,
              diff.domaineCode,
            )}
            nextCompetenceList={diff.competenceList}
          />
        )}
      </td>
      <td tw="p-3">
        {!_isEmpty(diff.matiereRemark) && (
          <>
            <div tw="text-xs text-success ">(+ Ajout)</div>
            <span tw="text-success font-semibold">
              {diff.matiereRemark || ''}
            </span>
          </>
        )}
      </td>
      <td tw="p-3">
        <DiffNote
          notationSystem={notationSystem}
          prevNote={currentNote}
          nextNote={diff.note}
        />
      </td>
    </tr>
  );
}
